import styled from 'styled-components'

import { COLORS } from 'consts/colors'
import { GRADIENTS, RADII } from 'styles/consts'
import { MOBILE_SIZE_BREAKPOINT } from 'consts'

export const RefillButton = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  /* 34px at every width: this sits directly next to Export in the header, and a
     height difference between the two pills reads as a misalignment. 34px is the
     shared header-button height — common-components Button (Export /
     ExportButtonSkeleton), UpgradeToExportButton and DiscountButton all use it. */
  height: 34px;
  border: none;
  border-radius: ${RADII.field};
  background: ${COLORS.magentaTint};
  cursor: pointer;

  & > svg {
    width: 20px;
    height: 20px;
    flex-shrink: 0;

    @media only screen and (max-width: ${MOBILE_SIZE_BREAKPOINT}px) {
      width: 18px;
      height: 18px;
    }
  }

  /* Gradient border revealed on hover (mask keeps only the 1px ring). */
  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: inherit;
    padding: 1px;
    background: ${GRADIENTS.pinkMagentaBorder};
    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    mask-composite: exclude;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.3s;
  }

  &:hover {
    box-shadow: 0px 0px 6px 0px #ff007b2e;

    &::after {
      opacity: 1;
    }
  }

  &:focus-visible {
    outline: 2px solid ${COLORS.primary};
    outline-offset: 2px;
  }
`

export const CreditsCount = styled.span`
  font-weight: 600;
  font-size: 14px;
  color: ${COLORS.textPrimary};

  @media only screen and (max-width: ${MOBILE_SIZE_BREAKPOINT}px) {
    max-width: 39px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

export const CreditsLabel = styled.span`
  font-size: 16px;
  font-weight: 700;
  background: ${GRADIENTS.pinkMagenta} text;
  -webkit-text-fill-color: transparent;
`
